import React from "react";
import Section_image from "../../assets/icons/Section_image1.png";
import { Button } from "@mui/material";
import { Container, LeftSection, RightSection, StyledLink, Text, Title } from "../../assets/styles/HomeStyles";
import { useNavigate } from "react-router-dom";

const MainContent = () => {
  const navigate = useNavigate();

  return (
    <>
    <Container>
      <LeftSection>
        <Title>Devia,<br /> A Powerful Platform</Title>
        <Text>
          that organizes all your data, giving you the <br/> freedom to select your
          customers, partners,<br/> distributors, vendors, and employees.
        </Text>
        <Text>
          <StyledLink>
            Be it Instant Checks, Background Checks <br/> or Due Diligence.
          </StyledLink>
        </Text>
        <Button className="custom-button" variant="contained"  onClick={() => navigate("/contact-us")}>
          Get Demo</Button>        
      </LeftSection>
      <RightSection>
        <img src={Section_image} alt="Platform Preview" width="100%" />
      </RightSection>
    </Container>
  
    </>
  );
};

export default MainContent;
